<template>
  <jet-authentication-card>
    <div class="flex flex-col space-y-6">
      <h1 class="text-xl text-center">
        Thanks for signing up!
      </h1>

      <div class="text-sm text-gray-600 text-center mb-10">
        Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another.
      </div>

      <div
        v-if="verificationLinkSent"
        class="font-medium text-sm text-green-600 text-center"
      >
        A new verification link has been sent to the email address you provided during registration.
      </div>

      <form @submit.prevent="submit">
        <div class="flex flex-col items-center">
          <jet-button
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Resend Verification Email
          </jet-button>
        </div>
      </form>
      <Link
        :href="route('logout')"
        method="post"
        as="button"
        class="underline text-sm text-gray-600 hover:text-gray-900"
      >
        Log Out
      </Link>
    </div>
  </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from '../../Jetstream/AuthenticationCard.vue';
import JetButton from '../../Jetstream/Button.vue';
import EmptyLayout from '../../Layouts/EmptyLayout.vue';
import {Link} from '@inertiajs/vue3'

export default {
  components: {
    JetAuthenticationCard,
    JetButton,
      Link,
  },
  layout: EmptyLayout,

  props: {
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form(),
    };
  },

  computed: {
    verificationLinkSent() {
      return this.status === 'verification-link-sent';
    },
  },

  methods: {
    submit() {
      this.form.post(this.route('verification.send'));
    },
  },
};
</script>
